import { useNavigate } from 'react-router';

import Button from 'layout/atoms/Button';
import Container from 'layout/atoms/Container';
import Logo from 'layout/atoms/Logo';

export const LoginPage = (props: { onUserLoggedIn: any }) => {
    const navigate = useNavigate();

    return (
        <Container size="s">
            <Logo center />
            <div>
                <Button theme="primary" onClick={() => navigate('/login')}>
                    Log in with email
                </Button>
            </div>
        </Container>
    );
};
